/* eslint-disable */
/**
 * Snapchat Pixel Integration Helper
 * Supports dynamic Pixel ID via URL param ?sc=xxxx or localStorage
 */

export const getSnapchatId = () => {
  try {
    // 1. Check window.location.search
    let params = new URLSearchParams(window.location.search);
    let sc = params.get('sc');

    // 2. Check window.location.hash if present
    if (!sc && window.location.hash.includes('?')) {
      const hashQuery = window.location.hash.split('?')[1];
      const hashParams = new URLSearchParams(hashQuery);
      sc = hashParams.get('sc');
    }

    // 3. Fallback to localStorage / sessionStorage
    if (sc) {
      localStorage.setItem('pixel_sc', sc);
      sessionStorage.setItem('pixel_sc', sc);
      return sc;
    }
    return localStorage.getItem('pixel_sc') || sessionStorage.getItem('pixel_sc') || null;
  } catch (e) {
    return localStorage.getItem('pixel_sc') || sessionStorage.getItem('pixel_sc') || null;
  }
};

export const initSnapchatPixel = (explicitId) => {
  const pixelId = explicitId || getSnapchatId();
  if (!pixelId) {
    console.log('[Snapchat Pixel] No SC ID found yet');
    return null;
  }

  // Inject Snapchat base code if not already present
  if (!window.snaptr) {
    (function (e, t, n) {
      if (e.snaptr) return;
      var a = (e.snaptr = function () {
        a.handleRequest ? a.handleRequest.apply(a, arguments) : a.queue.push(arguments);
      });
      a.queue = [];
      var s = 'script';
      var r = t.createElement(s);
      r.async = !0;
      r.src = n;
      var u = t.getElementsByTagName(s)[0];
      if (u && u.parentNode) {
        u.parentNode.insertBefore(r, u);
      } else {
        t.head.appendChild(r);
      }
    })(window, document, 'https://sc-static.net/scevent.min.js');
  }

  try {
    if (window.snaptr) {
      window.snaptr('init', pixelId);
      window.snaptr('track', 'PAGE_VIEW');
      console.log('[Snapchat Pixel] Initialized with ID:', pixelId);
    }
  } catch (err) {
    console.error('[Snapchat Pixel] Load error:', err);
  }

  return pixelId;
};

export const trackSnapchatEvent = (eventName, params = {}) => {
  try {
    // Ensure pixel initialized
    if (!window.snaptr) {
      initSnapchatPixel();
    }
    if (window.snaptr && typeof window.snaptr === 'function') {
      if (params && Object.keys(params).length > 0) {
        window.snaptr('track', eventName, params);
      } else {
        window.snaptr('track', eventName);
      }
      console.log('[Snapchat Pixel] Tracked event:', eventName, params);
    }
  } catch (err) {
    console.error('[Snapchat Pixel] Track error for', eventName, err);
  }
};

export default {
  getSnapchatId,
  initSnapchatPixel,
  trackSnapchatEvent,
};
